import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=1a5ae31d&scoped=true&"
import script from "./info-card.vue?vue&type=script&lang=ts&"
export * from "./info-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ae31d",
  null
  
)

export default component.exports